import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import Input from 'Components/Atoms/Input/Input';
import { cn } from 'Utils/cn';

export default function RHFInputNumber({ name, min, max, className, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, onBlur, ...props }, fieldState: { error } }) => (
                <Input
                    className={cn(
                        '[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]',
                        className,
                    )}
                    type="number"
                    min={min}
                    max={max}
                    step="any"
                    onChange={(e) => {
                        const stringValue = e.target.value;
                        const numericValue = stringValue === '' ? '' : Number(stringValue);
                        if (isNaN(numericValue)) {
                            return;
                        }
                        onChange?.(numericValue);
                    }}
                    onBlur={(e) => {
                        const value = e.target.value;
                        const numericValue = parseFloat(value);

                        if (isNaN(numericValue)) {
                            return;
                        }
                        if (min !== undefined && numericValue < min) {
                            onChange(min);
                            return;
                        }
                        if (max !== undefined && numericValue > max) {
                            onChange(max);
                            return;
                        }
                        onBlur(e);
                    }}
                    error={error?.message}
                    inputMode="decimal"
                    {...props}
                    {...other}
                />
            )}
        />
    );
}

RHFInputNumber.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
};
